import { types } from "mobx-state-tree";

export const QuestionAnswer = types.model("QuestionAnswer", {
  answer: types.optional(types.string, ''),
  question: types.optional(types.string, ''),
  related_to: types.optional(types.string, ''),
  uploadKey: types.maybe(types.string),
});